/**
 * Created by jpilz on 2/13/17.
 */
"use strict";
import {context} from '../../objects/context.js';
import ko from 'knockout';
import _ from 'lodash';
import $ from 'jquery';

import moment from 'moment';
import jobUtil from '../../objects/jobUtil.js';


class homeModel {

    constructor(params) {
        // Profile
        this.componentName = "nav-home";
        this.context = context;
        this.id = this.context.util.guid();
        this.visible = ko.observable(true);

        this.hasData = ko.observable(false);

        this.jobUtilObj = new jobUtil(this.context);

        this.componentMessage = ko.observable();

        this.jobHomeList = ko.observableArray();
        this.jobHomeChart = ko.observableArray();

        this.chartData = ko.observable({
            labels: ko.observable(["In Review:","Editing:"]),
            display: true,
					datasets: [
						{
							label: "Healthy People",
							backgroundColor: ["rgba(26,140,216,1)","rgba(38,166,91,1)","rgba(245, 145, 20,1)","rgba(46, 163, 229,1)","rgba(35,31,32,1)","rgba(51, 102, 204,0.8)","rgba(0, 153, 153,0.9)"],
							borderColor: "rgba(220,220,220,1)",
							pointColor: "rgba(220,220,220,1)",
							pointStrokeColor: "#fff",
							pointHighlightFill: "#fff",
							pointHighlightStroke: "rgba(220,220,220,1)",
							data: ko.observableArray([2,2]),
						}
					]
          });

        this.context.eventManager.subscribe((navObj) =>{
            this.handleNavChanged(navObj);
        },this, "navChanged");

        //ko.components.register('custom-options-report', require('../options/customReport/customReport').default);
        ko.components.register('custom-options', require('../options/customOptions/customOptions').default);

        this.init()

        console.log("nav-home:constructor: this: %o parms: %o",this, params);

    }

    init() {
        //this.getData();
    }

    handleNavChanged(navObj) {
        
        console.log("homeModel:handleNavChanged: navObj: %o", navObj);

        if(navObj == 'home')
        {
            this.visible(true);
            this.getData();
        }
        else
        {
            this.visible(false);
            this.componentMessage({message: ''});
        }
    }

    getData() {
        this.hasData(false);
        this.jobUtilObj.getJobHomeList().then( data => {
            console.log("nav-home:getData data: %o", data);
            if(data.length != 0){
                console.log("nav-home:getData hasData: %o", this.hasData());
                this.hasData(true);
            }
            this.jobHomeList(data);
            this.componentMessage({message: 'update'});
        }).catch( response => {
            console.log("nav-home:getData Error: %o", response);
        });

        this.getChartData();
    }

    getChartData() {
        
        this.jobUtilObj.getJobHomeChart().then( data => {
            console.log("nav-home:getChartData data: %o", data);
            this.jobHomeChart(data);
            this.chartData().labels(this.splitFilter(this.jobHomeChart(),'status'));
            this.chartData().datasets[0].data(this.splitFilter(this.jobHomeChart(),'total'));
            this.chartData.valueHasMutated();
            console.log("nav-home:getChartData this: %o", this);
        }).catch( response => {
            console.log("nav-home:getChartData Error: %o", response);
        }); 
    }

    splitFilter(arrayToSplit, prob) {

        let returnArray = [];

        console.log("nav-home:splitFilter");

        arrayToSplit.forEach((n, index) => {

            console.log("nav-home:splitFilter: n: %o index: %o", n, prob);
            console.log(n[prob]);
            returnArray.push(n[prob]);
        });

        console.log("nav-home:splitFilter: returnArray:", returnArray);

        return returnArray;
    }

    jobSelected(item, parent) {

        console.log("nav-home:jobSelected: item: %o", item);
        parent.context.eventManager.notifySubscribers({jobRefreshObj:item, updateNav: true},"jobRefresh");
    }


    formatdate(date) {
        //console.log("nav-home:formatdate date: %o", date)
        return moment(date.replace('Z','')).format('MMM D, YYYY h:mm A');
    }
    
}

export default { viewModel: homeModel, template: require('!raw-loader!./nav-home.html') };


// WEBPACK FOOTER //
// ./src/components/nav-home/nav-home.js